import { DataProxy, DocumentNode, Unmasked } from '@apollo/client'
import produce from 'immer'

const isObject = (item) => {
  return item && typeof item === 'object' && !Array.isArray(item)
}

const mergeDeep = (target, ...sources) => {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

export const genericUpdateQueryCache = async <TQuery, TQueryVariables>(
  store: DataProxy,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entity: Pick<any, 'id'>,
  query: DocumentNode,
  variables: TQueryVariables,
  dataKey: string,
  action: 'delete' | 'createOrUpdate',
): Promise<void> => {
  try {
    if (entity) {
      const data = store.readQuery<TQuery, TQueryVariables>({
        query: query,
        variables: variables,
      })

      if (data && data[dataKey] && entity) {
        const index = data[dataKey].findIndex((d) => d.id === entity.id)
        const nextData = produce(data, (draftState) => {
          if (action === 'createOrUpdate') {
            if (index !== -1) {
              draftState[dataKey][index] = mergeDeep(draftState[dataKey][index], entity)
            } else {
              draftState[dataKey] = [...draftState[dataKey], entity]
            }
          }
          if (action === 'delete' && index !== -1) {
            draftState[dataKey] = draftState[dataKey].filter((d) => d.id !== entity.id)
          }
        })

        store.writeQuery({
          query: query,
          variables: variables,
          data: nextData as Unmasked<NonNullable<Unmasked<TQuery>>>,
        })
      }
    }
  } catch (e) {
    console.log('cache update failed', e)
  }
}
